// src/components/MembersTable.js
import React, {useState} from 'react';
import './MembersTable.css';

const MembersTable = ({ data, userRole, handleDeleteMember, handleFeeChange }) => {

  return (
    <div className="members-table-container">
      <table className="members-table">
        <thead>
          <tr>
            {userRole === "commissioner" && (
              <th className="deleteHeader">Delete</th>
            )}
            <th className="nameHeader">Name</th>
            <th className="emailHeader">Email</th>
            <th className="feesHeader">Fees Paid</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {userRole === "commissioner" && (
                <td data-label="Delete">
                  <button 
                    className="delete-btn" 
                    onClick={() => handleDeleteMember(row._id)}
                  >
                    🗑️
                  </button>
                </td>
              )}
              <td>{row.name}</td>
              <td>{row.email}</td>
              <td>{row.feesPaid}
              <input
                type="checkbox"
                disabled={userRole !== 'commissioner'}
                // checked={row.feesPaid || false}
                checked={row.feesPaid || false}
                onChange={() =>handleFeeChange(row._id, row.feesPaid)}
              />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MembersTable;
